import { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import {
  AddCompany,
  Admin,
  AdminCategories,
  AdminRequest,
  AdminRequests,
  AllCompanies,
  Categories,
  CompanyInfo,
  Conversations,
  CreateRequest,
  CreateRequestStart,
  ForgotPassword,
  Home,
  Login,
  MyCompany,
  MyCompanyProduct,
  MyCompanyProducts,
  MyCompanyProfile,
  Registration,
  Search,
  User,
} from './pages'
import { useDispatch, useSelector } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { setToken } from './services/apiService'
import {
  getCategories,
  getCities,
  getMyCompany,
  getUserInfo,
} from './store/Actions'
import { delay } from './helpers'
import { AdminLayout } from './components'
import CompanyTransfer from './pages/admin/company_transfer/CompanyTransfer'
import AdminInfo from './pages/admin/info/AdminInfo'
import {
  deleteVisitedCompanies,
  getHomePageCompanies,
} from './store/Actions/Company'

export default function App() {
  const dispatch = useDispatch()

  const { token } = useSelector(state => state.authentication)
  // const a = useSelector(state => {
  //   console.log('state: ', state)
  // })

  const [appMounted, setAppMounted] = useState(false)

  useEffect(() => {
    const onTokenChange = async () => {
      if (token) {
        setToken(token)

        dispatch(getMyCompany())
        dispatch(getUserInfo({}))
        dispatch(deleteVisitedCompanies())
      }
    }

    onTokenChange()
  }, [token, dispatch])

  useEffect(() => {
    dispatch(getCategories())
    dispatch(getCities())
    dispatch(getHomePageCompanies())

    delay(100) // wait until apiToken is set
    setAppMounted(true)
  }, [dispatch])

  if (!appMounted) {
    return null
  }

  return (
    <>
      <ToastContainer />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />

          {/** Auth */}
          <Route path="/registracija" element={<Registration />} />
          <Route path="/prijava" element={<Login />} />
          <Route path="/zaboravljena-lozinka" element={<ForgotPassword />} />
          <Route path="/registracija-firme" element={<AddCompany />} />

          {/** My company */}
          <Route path="/moja-firma" element={<MyCompany />} />
          <Route path="/moja-firma/profil" element={<MyCompanyProfile />} />
          <Route path="/moja-firma/proizvodi" element={<MyCompanyProducts />} />
          <Route
            path="/moja-firma/proizvod/:proizvodId?"
            element={<MyCompanyProduct />}
          />

          {/** Common */}
          <Route path="/firma/:companyId" element={<CompanyInfo />} />
          <Route path="/sve-firme" element={<AllCompanies />} />
          <Route path="/pretraga" element={<Search />} />
          <Route path="/kategorije" element={<Categories />} />
          <Route path="/korisnik/:userId" element={<User />} />

          {/** Requests */}
          <Route path="/zahtjevi/kreiraj" element={<CreateRequest />} />
          <Route path="/zahtjevi/start" element={<CreateRequestStart />} />

          {/** Admin */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminRequests />} />
            <Route path="admin-zahtjev/:id" element={<AdminRequest />} />
            <Route path="admin-kategorije" element={<AdminCategories />} />
            <Route path="admin-transferi" element={<CompanyTransfer />} />
            <Route path="admin-info" element={<AdminInfo />} />
          </Route>

          {/** Messages */}
          <Route path="/poruke" element={<Conversations />} />
        </Routes>
      </Router>
    </>
  )
}
